import { render, staticRenderFns } from "./entrustInfo.vue?vue&type=template&id=52302b56&scoped=true"
import script from "./entrustInfo.vue?vue&type=script&lang=js"
export * from "./entrustInfo.vue?vue&type=script&lang=js"
import style0 from "./entrustInfo.vue?vue&type=style&index=0&id=52302b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52302b56",
  null
  
)

export default component.exports